// folderApiV2.ts
import axios from "axios";
import { BaseURl } from "../../utils"; // kept to match your existing pattern

// helper to get headers (reads token at call time)
const getAuthHeaders = (isForm = false) => {
  const token: string | null = localStorage.getItem("token");
  const headers: Record<string, string> = {
    // content-type: let axios set multipart/form-data boundary when using FormData
    "Content-Type": isForm ? "multipart/form-data" : "application/json",
  };
  if (token) headers["x-access-token"] = token;
  return headers;
};

// Create a new folder
export const createFolderApi = async (modify: any) => {
  try {
    const response = await axios.post(
      `${BaseURl}folders/create`,
      modify,
      { headers: getAuthHeaders(false) }
    );
    console.log(response, "hbufuihf")
    return response.data;
  } catch (error) {
    console.error("createFolderApi error:", error);
    throw error;
  }
};

// Get all folders for a mode (supports optional pagination params)
export const getFoldersByModeApi = async (modeid: string, userId: string, page_no = 1, page_size = 100) => {
  try {
    const url = `${BaseURl}folders/getall/${modeid}?page_no=${page_no}&page_size=${page_size}&userId=${userId}`;

    const response = await axios.get(url, {
      headers: getAuthHeaders(false),
    });

    return response.data;
  } catch (error) {
    console.error("getFoldersByModeApi error:", error);
    throw error;
  }
};


// Get folder by ID
export const getFolderByIdApi = async (folderId: any) => {
  try {
    const response = await axios.get(
      `${BaseURl}folders/getbyId/${folderId}`,
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("getFolderByIdApi error:", error);
    throw error;
  }
};

// Get all trash folders for a mode
export const getTrashFoldersApi = async (modeid: any, userId: string, page_no = 1, page_size = 100) => {
  try {
    const response = await axios.get(
      `${BaseURl}folders/getAllTrash/${modeid}?page_no=${page_no}&page_size=${page_size}&userId=${userId}`,
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("getTrashFoldersApi error:", error);
    throw error;
  }
};

// Get all starred folders for a mode
export const getStarredFoldersApi = async (modeId: any, userId: string, page_no = 1, page_size = 100) => {
  try {
    const response = await axios.get(
      `${BaseURl}folders/getallbystarred/${modeId}?page_no=${page_no}&page_size=${page_size}&userId=${userId}`,
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("getStarredFoldersApi error:", error);
    throw error;
  }
};

// Update folder
export const updateFolderApi = async (data: { id: any; modify: any }) => {
  const { id, modify } = data;
  try {
    const response = await axios.put(
      `${BaseURl}folders/update/${id}`,
      modify,
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("updateFolderApi error:", error);
    throw error;
  }
};

// Upload folder profile image
export const uploadFolderImageApi = async (data: { id: any; image: File }) => {
  const { id, image } = data;
  console.log("uploading image", id, image);

  try {
    const formData = new FormData();
    formData.append("image", image);

    const response = await axios.put(
      `${BaseURl}folders/uploadProfile/${id}`,
      formData,
      { headers: getAuthHeaders(true) }
    );
    console.log("uploaded image", response);
    return response.data;
  } catch (error) {
    console.error("uploadFolderImageApi error:", error);
    throw error;
  }
};

// Delete all folders by mode
export const deleteAllFoldersApi = async (modeId: any) => {
  try {
    const response = await axios.delete(
      `${BaseURl}folders/deleteAllFolder/${modeId}`,
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("deleteAllFoldersApi error:", error);
    throw error;
  }
};

// Soft delete folder (move to trash)
export const softDeleteFolderApi = async (id: any) => {
  try {
    const response = await axios.delete(
      `${BaseURl}folders/folderRemove/${id}`,
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("softDeleteFolderApi error:", error);
    throw error;
  }
};

// Permanently delete folder
export const deleteFolderPermanentlyApi = async (id: any) => {
  try {
    const response = await axios.delete(
      `${BaseURl}folders/deleteFolderByIdPermanently/${id}`,
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("deleteFolderPermanentlyApi error:", error);
    throw error;
  }
};

// Delete multiple folders (expects folderIds: any[])
export const deleteMultipleFoldersApi = async (folderIds: any[]) => {
  try {
    const response = await axios.post(
      `${BaseURl}folders/delete-multiple`,
      { folderIds },
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("deleteMultipleFoldersApi error:", error);
    throw error;
  }
};

// Share multiple folders
export const shareMultipleFoldersApi = async (data: { folderIds: string[]; userIds: string[] }) => {
  try {
    const response = await axios.post(
      `${BaseURl}folders/share-multiple`,
      data,
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("shareMultipleFoldersApi error:", error);
    throw error;
  }
};

// Mark folder as starred
export const markFolderAsStarredApi = async (id: any) => {
  try {
    const response = await axios.put(
      `${BaseURl}folders/foldermarkedstarred/${id}`,
      {}, // no body
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("markFolderAsStarredApi error:", error);
    throw error;
  }
};

// Unmark folder as starred
export const unmarkFolderAsStarredApi = async (id: any) => {
  try {
    const response = await axios.put(
      `${BaseURl}folders/folderunmarkedstarred/${id}`,
      {}, // no body
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("unmarkFolderAsStarredApi error:", error);
    throw error;
  }
};

// Restore folder from trash
export const restoreFolderApi = async (id: any) => {
  try {
    const response = await axios.put(
      `${BaseURl}folders/restoreFolder/${id}`,
      {}, // no body
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("restoreFolderApi error:", error);
    throw error;
  }
};

// In src/redux/Api/fileApi.ts
export const toggleFolderStatus = async (folderId: string) => {
  const response = await axios.put(
    `${BaseURl}folders/statusToggle/${folderId}`,
    {},
    {
      headers: getAuthHeaders(false)
    }
  );
  return response.data;
};

// Get shared folders for a user
export const getSharedFoldersApi = async (userId: string, page_no = 1, page_size = 100) => {
  try {
    const url = `${BaseURl}folders/shared/${userId}?page_no=${page_no}&page_size=${page_size}`;
    const response = await axios.get(url, {
      headers: getAuthHeaders(false),
    });
    return response.data;
  } catch (error) {
    console.error("getSharedFoldersApi error:", error);
    throw error;
  }
};

// Remove a shared folder for a user
export const removeSharedFolderApi = async (folderId: string, userId: string) => {
  try {
    const response = await axios.delete(
      `${BaseURl}folders/shared/${folderId}/${userId}`,
      { headers: getAuthHeaders(false) }
    );
    return response.data;
  } catch (error) {
    console.error("removeSharedFolderApi error:", error);
    throw error;
  }
};
